module.exports = __webpack_public_path__ + "img/icon_kuku_diagnosis.55bfbd74.png";